import { Cpu, Money } from "@phosphor-icons/react";
import type { OfficialModel } from "../types";
import { formatTokenPrice } from "./per-token-pricing-calculator/util";

export default function ModelPriceBadge({
  hardware,
  officialModel,
}: {
  hardware: string;
  officialModel?: OfficialModel;
}) {
  let icon: React.ReactElement;
  let disclosure: string;

  if (
    officialModel &&
    officialModel.billing_unit === "1m-tokens" &&
    officialModel.cost_per_billing_unit_for_input_dollars &&
    officialModel.cost_per_billing_unit_for_output_dollars
  ) {
    icon = <Money />;
    disclosure = "Priced per token";
  } else if (
    officialModel &&
    officialModel.billing_unit === "image" &&
    officialModel.cost_per_billing_unit_for_output_dollars
  ) {
    icon = <Money />;
    const price = formatTokenPrice(
      Number(officialModel.cost_per_billing_unit_for_output_dollars)
    );
    disclosure = `${price} per image`;
  } else {
    icon = <Cpu />;
    disclosure = hardware;
  }

  return (
    <div className="flex items-center gap-1.5">
      {icon}
      <a href="#pricing" className="text-r8-sm">
        {disclosure}
      </a>
    </div>
  );
}
